import React, { useContext } from 'react';

import EditLetter from '@/views/pages/Letter/elements/EditLetter';
import { TextContext } from '@/utils/contexts/TextContext';

const EditLetterWrapper = () => {
	const { contextState } = useContext(TextContext);

	return (
		<>
			{   contextState.editLetterMetadata && (
				<EditLetter />
			)}
		</>
	);
};

export default EditLetterWrapper;